import { render, staticRenderFns } from "./AddPricePlanBtn.vue?vue&type=template&id=caf49088&"
import script from "./AddPricePlanBtn.vue?vue&type=script&lang=ts&"
export * from "./AddPricePlanBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign({QBtn}, component.options.components || {})
